// extracted by mini-css-extract-plugin
export default {"main":"TipoAsignaturaSelector_main__ryeNf"};